import { render, staticRenderFns } from "./MantenedorTipoUbicacionBase.vue?vue&type=template&id=d2b9d720&"
import script from "./MantenedorTipoUbicacionBase.vue?vue&type=script&lang=ts&"
export * from "./MantenedorTipoUbicacionBase.vue?vue&type=script&lang=ts&"
import style0 from "./MantenedorTipoUbicacionBase.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('d2b9d720', component.options)
    } else {
      api.reload('d2b9d720', component.options)
    }
    module.hot.accept("./MantenedorTipoUbicacionBase.vue?vue&type=template&id=d2b9d720&", function () {
      api.rerender('d2b9d720', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/MantenedorTipoUbicacion/MantenedorTipoUbicacionBase.vue"
export default component.exports